<template>
    <article class="product-card" v-if="product" @click="handleClick">
        <div class="product-card__content">
            <div class="product-card__wrap">
                <div v-if="product.created_at" class="product-card__date">
                    {{ formatDate(product.created_at) }}
                </div>
                <h3 class="product-card__title">{{ product.name }}, {{ product.year }}</h3>
            </div>
            <p class="product-card__desc">
                {{
                    product.description ||
                    'Опишите ваши вкусовые ощущения, сладость, терпкость или чем хотите поделиться'
                }}
            </p>
            <div class="product-card__cta" @click.stop="handleClick">More details →</div>
        </div>

        <div class="product-card__image">
            <img :src="imageSrc()" :alt="product.name" />
        </div>
    </article>
</template>

<script setup lang="ts">
import productPlaceholder from '@/assets/images/product_placeholder.png'
import { Product } from '@/types'
import { formatDateRu } from '@/utils/dates'
import { useRouter } from 'vue-router'

// Props
interface Props {
    product: Product
    showActions?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    showActions: false,
})

// Emits
const emit = defineEmits<{
    click: [product: Product]
    favorite: [product: Product, isFavorite: boolean]
    share: [product: Product]
}>()

const router = useRouter()

const imageSrc = () => {
    const url = props.product.product_image?.url
    if (!url) return productPlaceholder
    if (
        url.startsWith('http://') ||
        url.startsWith('https://') ||
        url.startsWith('data:') ||
        url.startsWith('/')
    ) {
        return url
    }
    return productPlaceholder
}

const formatDate = (dateString: string) => formatDateRu(dateString)

// Methods
const handleClick = () => {
    emit('click', props.product)
    router.push({ name: 'product-info' })
}
</script>

<style scoped lang="stylus">
.product-card
    display flex
    align-items stretch
    justify-content space-between
    gap 8px
    padding 0 0 24px
    width 100%
    height 244px
    border-bottom 1px solid var(--app-border-light)
    &__content
        display flex
        flex-direction column
        gap 12px

    &__image
        position relative
        min-width 81px
        height 100%
        flex 0 0 81px
        overflow hidden
        img
            width 100%
            height 100%
            object-fit contain
    &__more
        position absolute
        right 4px
        bottom 4px
        display inline-flex
        align-items center
        justify-content center
        width 28px
        height 28px
        border none
        border-radius 999px
        background rgba(0,0,0,.5)
        color var(--app-text-light-color)
        cursor pointer
    // &__rating

    &__date
        font-size 10px
        line-height 12px
        font-weight 400
        color var(--app-hint-color)

    &__title
        font-size 16px
        line-height 21px
        font-weight 600
        color var(--app-text-color)
        text-transform uppercase

    &__desc
        font-size 14px
        line-height 21px
        font-weight 400
        color var(--app-text-color)
        overflow hidden
        display -webkit-box
        -webkit-line-clamp 4
        -webkit-box-orient vertical
        word-break break-word

    &__cta
        margin-top auto
        font-size 16px
        line-height 19px
        font-weight 500
        color var(--app-main-accent-color)
</style>
